import { render } from "./PropertyBrokerInfo.vue?vue&type=template&id=fe6720c2"
import script from "./PropertyBrokerInfo.vue?vue&type=script&lang=js"
export * from "./PropertyBrokerInfo.vue?vue&type=script&lang=js"

import "./PropertyBrokerInfo.vue?vue&type=style&index=0&id=fe6720c2&lang=css"

import exportComponent from "/var/app/current/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__